import React from 'react';
import IconButton from '@zvuk-b2b/react-uikit/ui/IconButton';
import IconCopy from '@zvuk-b2b/react-uikit/ui/icons/Copy';
import IconTrash2 from '@zvuk-b2b/react-uikit/ui/icons/Trash2';
import { TEXTS } from '../../../texts';
import styles from './index.module.scss';

interface MediafileActionsProps {
  id?: string | null;
  onCopyMediafile: (id: string) => void;
  onRemoveMediafile: (id: string) => void;
}

const MediafileActions: React.FC<MediafileActionsProps> = ({ id, onCopyMediafile, onRemoveMediafile }) => {
  const onCopyClick = () => {
    if (id) {
      onCopyMediafile(id);
    }
  };

  const onRemoveClick = () => {
    if (id) {
      onRemoveMediafile(id);
    }
  };

  return (
    <div className={styles.buttons}>
      <IconButton
        onClick={onCopyClick}
        hint={TEXTS.DUPLICATE}
        className={styles.actionButton}
        elementId="copy_video_mediafile_button">
        <IconCopy className={styles.icon} />
      </IconButton>
      <IconButton
        className={styles.actionButton}
        hint={TEXTS.REMOVE_FROM_VIDEO_STREAM}
        elementId="remove_video_mediafile_button"
        onClick={onRemoveClick}>
        <IconTrash2 className={styles.icon} />
      </IconButton>
    </div>
  );
};

export default MediafileActions;
